// extracted by mini-css-extract-plugin
export var relate = "l_bC";
export var title = "l_bq";
export var listPanel = "l_bD";
export var listBox = "l_bF";
export var relateDetail = "l_bG";
export var img = "l_bz";
export var contentWrap = "l_bH";
export var content = "l_bv";
export var msgBox = "l_bJ";
export var nameWrap = "l_bK";
export var avatar = "l_bx";
export var name = "l_bL";
export var likes = "l_bM";
export var icon = "l_bN";
export var likeNum = "l_bP";
export var filp = "l_bQ";